<template>
  <div class="testimonial-carousel">
    <div class="carousel-container">
      <button class="carousel-control prev" @click="prevSlide">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          stroke="black"
          stroke-width="2"
        >
          <circle cx="24" cy="24" r="22" fill="white" stroke="black" stroke-width="2" />
          <polyline
            points="28,16 20,24 28,32"
            fill="none"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <div
        class="testimonial"
        v-show="currentIndex === index"
        v-for="(testimonial, index) in testimonials"
        :key="index"
      >
        <div class="avatar-group">
          <div
            class="avatar-container"
            v-for="(avatar, idx) in testimonial.avatars"
            :key="idx"
            :class="{ 'avatar-active': idx === 1, 'avatar-left': idx === 0, 'avatar-right': idx === 2 }"
          >
            <img :src="require(`../../assets/newlanding/Landing/${avatar}`)" class="avatar-img" alt="Avatar" />
          </div>
        </div>
        <div class="testimonial-content">
          <blockquote class="testimonial-quote">{{ testimonial.quote }}</blockquote>
          <div class="testimonial-text">{{ testimonial.text }}</div>
          <div class="testimonial-author">
            <strong>{{ testimonial.author }}</strong
            >, {{ testimonial.position }}
          </div>
        </div>
      </div>
      <button class="carousel-control next" @click="nextSlide">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          stroke="black"
          stroke-width="2"
        >
          <circle cx="24" cy="24" r="22" fill="white" stroke="black" stroke-width="2" />
          <polyline
            points="20,16 28,24 20,32"
            fill="none"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <div class="carousel-indicators">
      <span
        v-for="(testimonial, index) in testimonials"
        :key="index"
        class="indicator"
        :class="{ active: currentIndex === index }"
        @click="goToSlide(index)"
      >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestimonialCarousel",
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      testimonials: [
        {
          quote: "«Historias de éxito»",
          text: "Ingresé a Konecta en el año 2009 como teleoperador, y hoy, después de 16 años ocupo un cargo directivo. Konecta me permitió terminar mis estudios, seguir formándome, y crecer. Soy una de las tantas historias de éxito de esta gran empresa.",
          author: "Victor Ruiz",
          position: "Vice Presidente de Operaciones",
          avatars: ["rodrigoocana.jpeg", "victorluis.jpg", "geraldinerolan.jpeg"],
        },
        {
          quote: "«Beneficios que trascienden»",
          text: "Agradecida con la empresa que me da muchos beneficios, eso me permitió pagar mis estudios universitarios. Hoy, soy Bachiller de Psicología, llevo 10 años en la empresa y soy parte del equipo de Desarrollo Organizacional.",
          author: "Geraldine Roldan",
          position: "Responsable de Gestión de Talento",
          avatars: ["victorluis.jpg", "geraldinerolan.jpeg", "andresbogetto.png"],
        },
        {
          quote: "«Mi opinión es valorada»",
          text: "Tengo 20 años en la empresa. Encontré un lugar en el que me siento parte de los logros alcanzados. Siento que puedo aportar y mi opinión es valorada.",
          author: "Andres Bogetto",
          position: "Director de Operaciones",
          avatars: ["geraldinerolan.jpeg", "andresbogetto.png", "maryorisaladana.jpeg"],
        },
        {
          quote: "«Sueños por cumplir»",
          text: "Llevo 8 años en la empresa, y estar aquí me ha permitido crecer como persona y formarme profesionalmente, realizando una línea de carrera desde operadora hasta Analista en Responsabilidad Social. Doy fe de que se pueden lograr las metas y sueños que nos propongamos.",
          author: "Maryori Saldaña",
          position: "Analista de Responsabilidad Social",
          avatars: ["andresbogetto.png", "maryorisaladana.jpeg", "rodrigoocana.jpeg"],
        },
        {
          quote: "«Clave para mi crecimiento»",
          text: "Konecta me brindó ayuda cuando más lo necesitaba, me permitió conocer a personas increíbles y aprender de todos ellos. Esta empresa ha sido clave en mi crecimiento personal y profesional, por lo que siempre le estaré agradecido. Espero poder seguir brindándole mi tiempo, aportando a su crecimiento empresarial y, a la vez, seguir aprendiendo de su gente.",
          author: "Rodrigo Ocaña",
          position: "Coordinador de Experiencia",
          avatars: ["maryorisaladana.jpeg", "rodrigoocana.jpeg", "victorluis.jpg"],
        },
        // Add more testimonials as needed
      ],
      currentIndex: 0,
      timer: null,
    };
  },
  mounted() {
    if (this.autoplay) {
      this.startAutoplay();
    }
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, this.interval);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.testimonials.length;
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.testimonials.length) % this.testimonials.length;
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
  },
};
</script>

<style scoped>
.testimonial-carousel {
  width: 70%;
  margin: 60px auto;
  position: relative;
}
.carousel-container {
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.testimonial {
  text-align: center;
  padding: 30px 20px;
  width: 70%;
  margin: 0 auto;
}

.avatar-group {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.avatar-container {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  opacity: 0.5;
  margin: 0 -10px;
}

.avatar-active {
  width: 140px;
  height: 140px;
  opacity: 1;
  z-index: 2;
  border: 3px solid #2800c8;
}

.avatar-left,
.avatar-right {
  transform: scale(0.8);
  z-index: 1;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-content {
  margin-top: 20px;
}

.testimonial-quote {
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 20px;
  color: #000;
}

.testimonial-text {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
  color: #333;
}

.testimonial-author {
  font-size: 16px;
  color: #555;
  margin-top: 15px;
}

.carousel-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.carousel-control {
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
}

.carousel-control.prev {
  left: 0px; /* puedes ajustar el valor */
}

.carousel-control.next {
  right: 0px; /* puedes ajustar el valor */
}

.carousel-control:hover {
  background: #f0f0f0;
}

/* Separar los indicadores */
.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ddd;
  margin: 0 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background-color: #2800c8;
  transform: scale(1.2);
}

@media (max-width: 900px) {
  .testimonial-carousel {
    width: 95%;
    padding: 30px 0px;
    margin: 10px auto;
  }
  .testimonial {
    text-align: center;
    padding: 0px;
    width: 90%;
    margin: 0 auto;
  }
  .avatar-left,
  .avatar-right {
    width: 80px;
    height: 80px;
  }
  .avatar-active {
    width: 100px;
    height: 100px;
  }
}
</style>
